import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RestaurantService } from 'src/app/shared/services/restaurant-services.';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
import { ConfirmationDialogueComponent } from 'src/app/shared/modal/confirmation-dialogue/confirmation-dialogue.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-banking-details',
  templateUrl: './banking-details.component.html',
  styleUrls: ['./banking-details.component.scss']
})
export class BankingDetailsComponent implements OnInit {

  infoDivVisible:boolean=false
  accountHolderName:any = "Enter account holder's name";
  detailsAvailable:boolean;

  constructor(
    private restoService:RestaurantService,
    private fb: FormBuilder,
    private dialogue: MatDialog
  ) { }

  bankDetails:any;

  ngOnInit(): void {
    this.getBankDetails();
  }

    toggleInfoDiv() {
      this.restoService.connectToStripe({}).subscribe((res:any)=>{
          let link = res.output.accountLink;
          let a = document.createElement('a');
          a.href = link?.url;
          // a.target = '_blank';
          a.click();
      })
      return

  }

  onUnlinkClink(){
    this.unLinkAccountPopup();
  }

  bankForm = this.fb.group({
    name: new FormControl('', [Validators.required]),
    accountNumber: new FormControl('', [Validators.required]),
    bankName: new FormControl('', [Validators.required]),
  });

  getBankDetails(){
    this.restoService.getBankDetails().subscribe((res:any)=>{
      this.bankDetails = res.output;
      if(this.bankDetails?.bank_name){
        this.detailsAvailable =true;
      }else{
        this.detailsAvailable =false;
      }

      if(this.detailsAvailable){
        if(!this.bankDetails?.account_holder_name){
          this.bankForm.get('name').patchValue('XXXXXXXX');
        }else{
          this.bankForm.get('name').patchValue(this.bankDetails?.account_holder_name);
        }
        let accountNumber = `xxxx xxxx xxxx ${this.bankDetails?.last4}`
        this.bankForm.get('accountNumber').patchValue(accountNumber);
        this.bankForm.get('bankName').patchValue(this.bankDetails?.bank_name);
      }
    })
  }

  updateBankDetails(){
    let data = {
      "accountHolderName": this.bankForm.value.name,
      "account_number": this.bankForm.value.accountNumber,
      "bank_name": this.bankForm.value.bankName
  }
    this.restoService.updateBankDetails(data).subscribe((res:any)=>{

    })
  }

  unLinkAccountPopup() {
    try {

      const dialogRef = this.dialogue.open(ConfirmationDialogueComponent, {
        id:'delete-team',
        hasBackdrop: true,
        disableClose: true,
        width: '469px',
        data: {
          userType: {
            titleOne: 'Are you sure you want to delete the Stripe Account?',
            text: "",
            imgPath: './../../../../assets/icon/delete -icon.png',
            access: "unLinkAccount",
          }
        },
      });

    }
    catch (e) { }
  }

}
